import { render, staticRenderFns } from "./PleitoConformidadeTecnica.vue?vue&type=template&id=2228ebeb"
import script from "./PleitoConformidadeTecnica.vue?vue&type=script&lang=js"
export * from "./PleitoConformidadeTecnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports